import React, { useState } from 'react';
import { Header } from './Header';
import { Problem } from './Problem';
import { Solution } from './Solution';
import { Testimonials } from './Testimonials';
import { Reviews } from './Reviews';
import { WebinarDetails } from './WebinarDetails';
import { FAQ } from './FAQ';
import { Benefits } from './Benefits';
import { CallToAction } from './CallToAction';
import { MoreTestimonials } from './MoreTestimonials';
import { Footer } from './Footer';
import { WebinarModal } from './WebinarModal';
export const Advertorial = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => {
    window.location.href = 'https://stresslessdogs.nl/meta-mcc-adv';
  };
  const closeModal = () => setIsModalOpen(false);
  return <div className="max-w-3xl mx-auto px-4 py-6 font-sans text-gray-800" data-id="element-8">
      <WebinarModal isOpen={isModalOpen} onClose={closeModal} data-id="element-9" />
      <Header openModal={openModal} data-id="element-10" />
      <Problem openModal={openModal} data-id="element-11" />
      <Solution openModal={openModal} data-id="element-12" />
      <Testimonials openModal={openModal} data-id="element-13" />
      <WebinarDetails openModal={openModal} data-id="element-14" />
      <Reviews data-id="element-15" />
      <FAQ openModal={openModal} data-id="element-16" />
      <Benefits openModal={openModal} data-id="element-17" />
      <CallToAction openModal={openModal} data-id="element-18" />
      <MoreTestimonials data-id="element-19" />
      <div className="mb-8 text-center" data-id="element-20">
        <button onClick={openModal} className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg transition duration-200" data-id="element-21">
          Klik hier voor meer informatie over het webinar
        </button>
      </div>
      <Footer openModal={openModal} data-id="element-22" />
    </div>;
};